<div class="main-container">
  <ng-template [ngIf]="userLoading$ | async">
    <div class="mat-spinner-container">
      <loader></loader>
    </div>
  </ng-template>

  <ng-template [ngIf]="user$ | async">
    <section class="container-title-actions">
      <div class="title">
        <h1>User Details</h1>
      </div>
      <ng-template [ngIf]="isCompanyManager(userDetails.roles)">
        <div class="actions">
          <go-back [routerLink]="['/dashboard/users']"></go-back>
          <gbui-button simple class="buttons-outline" (click)="OpenModal()"
            >Delete User</gbui-button
          >
        </div>
      </ng-template>
    </section>

    <section class="profile-image-container">
      <div class="image-container">
        <ng-container *ngIf="uploadPhotoLoading$ | async">
          <loader></loader>
        </ng-container>

        <img
          *ngIf="!(uploadPhotoLoading$ | async)"
          class="profile-image"
          [src]="profilePhoto || '/assets/icons/no-profile-image.svg'"
          alt=""
        />
        <div class="update-image">
          <input
            accept=".png, .jpg, .jpeg"
            (change)="onFileSelected($event)"
            type="file"
          />

          <img
            class="icon-upload-edit"
            [src]="
              profilePhoto
                ? '/assets/icons/pen.png'
                : '/assets/icons/update-profile-image.png'
            "
            alt=""
          />
        </div>
      </div>
    </section>

    <section class="form-container" [formGroup]="form">
      <div class="input-container">
        <label for="">First name</label>
        <input
          placeholder="Your Name"
          formControlName="firstName"
          [ngClass]="{
            'invalid-input':
              !form.controls['firstName'].valid &&
              form.controls['firstName'].touched,
            'disable-content': formDisabled
          }"
        />
        <label
          class="scale-up-ver-top"
          *ngIf="
            !form.controls['firstName'].valid &&
            form.controls['firstName'].touched
          "
        >
          Required
        </label>
      </div>
      <div class="input-container">
        <label for="">Last Name</label>
        <input
          [ngClass]="{ 'disable-content': formDisabled }"
          placeholder="Your Last Name"
          formControlName="lastName"
        />
      </div>
      <div class="input-container">
        <label for="">Job Title</label>
        <input
          [ngClass]="{ 'disable-content': formDisabled }"
          formControlName="jobTitle"
          placeholder="Your Job Title"
        />
      </div>
      <div class="input-container">
        <label for="">Email</label>
        <input
          [ngClass]="{ 'disable-content': formDisabled }"
          formControlName="email"
          placeholder="tonygrote@checkplus.com"
        />
      </div>
      <!-- <div class="input-container">
        <label for="">Phone Number</label>
        <input
          [ngClass]="{ 'disable-content': formDisabled }"
          formControlName="phone"
          placeholder="+55 555 555 555"
        />
      </div> -->
      <div class="input-container">
        <label for="">Department</label>
        <input
          [ngClass]="{ 'disable-content': formDisabled }"
          formControlName="department"
          placeholder="Enter department here"
        />
      </div>
      <div class="input-container">
        <label for="">Select type of user</label>
        <select
          formControlName="role"
          [ngClass]="{ 'disable-content': formDisabled }"
          name=""
          id=""
        >
          <option selected disabled>Select type</option>
          <option value="approver">Approver</option>
          <option value="requester">Requester</option>
          <!-- <option value="requester-approver">Requestor + Approver</option> -->
        </select>
      </div>
    </section>

    <section class="button-container">
      <gbui-button
        class="buttons-outline"
        (click)="edit()"
        [busy]="updateUserLoading$ | async"
      >
        {{ formDisabled ? "Edit" : "Save" }}
      </gbui-button>
    </section>
  </ng-template>
</div>
